export const REMINDER_ADDED = "REMINDER_ADDED";
export const REMINDER_CHANGED = "REMINDER_CHANGED";
export const REMINDER_REMOVED = "REMINDER_REMOVED";
